import { ReactNode } from "react"
import { descriptionStyle, h2Style } from "./index.css"

type Props = {
  title: string
  paragraphs: (string | ReactNode)[]
  marginTop?: string
  reduceSize?: boolean
}

/**
 *
 * @param marginTop defaults to 6rem
 * @returns Title with paragraph list
 */
const TextBlockDetailed = ({
  title,
  paragraphs,
  marginTop = "4rem",
  reduceSize,
}: Props) => {
  return (
    <>
      <h2
        className={h2Style}
        style={{
          marginTop,
          fontSize: reduceSize ? "22px" : "revert-layer",
          lineHeight: reduceSize ? "1.6rem" : "revert-layer",
        }}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        style={{
          marginTop: "1.5rem",
          fontSize: reduceSize ? "16px" : "revert-layer",
          lineHeight: reduceSize ? "1.2rem" : "revert-layer",
        }}
      >
        {paragraphs.map((para, i) =>
          typeof para === "string" ? (
            <span className={descriptionStyle} key={para}>
              {para}
            </span>
          ) : (
            <span key={`link-${i}`}>{para}</span>
          )
        )}
      </p>
    </>
  )
}

export default TextBlockDetailed
